import React from 'react';
import { Badge, Box, Flex, Stack, Text } from '@mantine/core';

import { getPcrStatusBadge } from '../../utility/pcrStatusBadge';
import { ViewPriceChangeRequestButton } from './ViewPriceChangeRequestButton';

export interface SurveyHistoryPcrItem {
    id: string;
    friendlyId?: number | null;
    surveyItemId: string;
    latestStatus: string;
    createdAt: string;
}

interface SurveyHistoryPcrListProps {
    pcrItems: SurveyHistoryPcrItem[];
}

export function SurveyHistoryPcrList({ pcrItems }: SurveyHistoryPcrListProps) {
    return (
        <Stack gap="md">
            {pcrItems.map(item => {
                const statusBadge = getPcrStatusBadge(item.latestStatus);
                return (
                    <Box
                        key={item.id}
                        className="bg-white rounded-lg p-4 shadow-sm"
                    >
                        <Flex align="center" gap="sm" wrap="wrap">
                            <Text fw={600} size="md">
                                Price Change Request
                                {item.friendlyId != null &&
                                    ` #${item.friendlyId}`}
                            </Text>
                            <Badge
                                color={statusBadge.color}
                                size="sm"
                                variant="light"
                            >
                                {statusBadge.label}
                            </Badge>
                        </Flex>
                        <Box mt={4}>
                            <ViewPriceChangeRequestButton requestId={item.id} />
                        </Box>
                    </Box>
                );
            })}
        </Stack>
    );
}
